import { apiURLNew, callAPI } from 'api/main';

interface IAccepteNewTermsOfUse {
  termId: number;
  latestTermVersion: number;
  privacyId: number;
  latestPrivacyVersion: number;
}

export default async ({
  termId,
  latestTermVersion,
  privacyId,
  latestPrivacyVersion,
}: IAccepteNewTermsOfUse): Promise<any> => {
  try {
    await Promise.all([
      await callAPI({
        url: `${apiURLNew}/terms/v1/accept-term`,
        method: 'POST',
        needToken: true,
        isLegacy: false,
        params: {
          term_id: termId,
          version: String(latestTermVersion),
        },
      }),
      await callAPI({
        url: `${apiURLNew}/terms/v1/accept-term`,
        method: 'POST',
        needToken: true,
        isLegacy: false,
        params: {
          term_id: privacyId,
          version: String(latestPrivacyVersion),
        },
      }),
    ]);

    return null;
  } catch (ex) {
    return null;
  }
};
